import Input from "@/components/Usados/InputField";
import Label from "@/components/Usados/Label";
import Button from "@/components/ui/button/Button";
import Alert from "@/components/ui/alert/Alert";
import { useState, useEffect } from "react";
import { useParams } from "react-router";
import Select from "@/components/Usados/Select";
import { apiFetch } from "@/service/api";

export default function CrearActividadTab({
  actividad,
  onSuccess,
  onCancel,
}: any) {
  const { id: proyecto_id } = useParams();
  const isEdit = !!actividad;

  const [form, setForm] = useState<any>({
    nombre: "",
    descripcion: "",
    estado_actividad: 1,
    prioridad: 1,
    fecha_inicio: "",
    fecha_fin_estimada: "",
    costo: 0,
    requiere_soporte: false,
  });
  const [file, setFile] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (actividad) {
      setForm({
        nombre: actividad.nombre,
        descripcion: actividad.descripcion,
        estado_actividad: actividad.estado_actividad,
        prioridad: actividad.prioridad,
        fecha_inicio: actividad.fecha_inicio?.split("T")[0],
        fecha_fin_estimada: actividad.fecha_fin_estimada?.split("T")[0],
        costo: actividad.costo,
        requiere_soporte: actividad.requiere_soporte,
        soporte_url: actividad.soporte_url,
      });
    }
  }, [actividad]);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      let soporte_url = form.soporte_url;

      if (file && isEdit) {
        const fd = new FormData();
        fd.append("file", file);
        const up = await apiFetch(
          `actividades-proyectos/upload-soporte/${actividad.id}`,
          {
            method: "POST",
            body: fd,
          },
        );
        if (up.ok) {
          const d = await up.json();
          soporte_url = d.soporte_url || d.url;
        }
      }

      const payload = {
        proyecto_id: Number(proyecto_id),
        nombre: form.nombre,
        descripcion: form.descripcion,
        estado_actividad: Number(form.estado_actividad),
        prioridad: Number(form.prioridad),
        fecha_inicio: form.fecha_inicio,
        fecha_fin_estimada: form.fecha_fin_estimada,
        costo: Number(form.costo || 0),
        requiere_soporte: Boolean(form.requiere_soporte),
        soporte_url,
      };

      const url = isEdit
        ? `actividades-proyectos/update/${actividad.id}`
        : `actividades-proyectos/create`;
      const method = isEdit ? "PATCH" : "POST";

      const res = await apiFetch(url, {
        method,
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Error");

      if (!isEdit && file && data.id) {
        const fd = new FormData();
        fd.append("file", file);
        await apiFetch(`actividades-proyectos/upload-soporte/${data.id}`, {
          method: "POST",
          body: fd,
        });
      }

      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
        onSuccess?.();
      }, 800);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h- rounded-2xl border border-gray-200 bg-white px-6 py-8 dark:border-gray-800 dark:bg-white/[0.03]">
      {error && <Alert variant="error" title="Error" message={error} />}
      {success && (
        <Alert
          variant="success"
          title="Éxito"
          message="Actividad guardada correctamente"
        />
      )}
      <form onSubmit={handleSubmit} className="space-y-6 max-w-4xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="col-span-2">
            <Label>Nombre de la actividad *</Label>
            <Input
              value={form.nombre}
              onChange={(e: any) =>
                setForm({ ...form, nombre: e.target.value })
              }
              required
              placeholder="Ej: Cimentación"
            />
          </div>
          <div className="col-span-2">
            <Label>Descripción</Label>
            <textarea
              value={form.descripcion}
              onChange={(e: any) =>
                setForm({ ...form, descripcion: e.target.value })
              }
              className="w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2"
              rows={3}
            />
          </div>
          <div>
            <Label>Costo (se resta del presupuesto) *</Label>
            <Input
              type="number"
              value={form.costo}
              onChange={(e: any) => setForm({ ...form, costo: e.target.value })}
              required
              placeholder="0"
            />
          </div>
          <div>
            <Label>Estado</Label>
            <Select
              value={form.estado_actividad}
              onChange={(v: any) => setForm({ ...form, estado_actividad: v })}
              options={[
                { value: "1", label: "Pendiente" },
                { value: "2", label: "En Progreso" },
                { value: "3", label: "Completada" },
              ]}
            />
          </div>
          <div>
            <Label>Fecha Inicio *</Label>
            <Input
              type="date"
              value={form.fecha_inicio}
              onChange={(e: any) =>
                setForm({ ...form, fecha_inicio: e.target.value })
              }
              required
            />
          </div>
          <div>
            <Label>Fecha Fin Estimada *</Label>
            <Input
              type="date"
              value={form.fecha_fin_estimada}
              onChange={(e: any) =>
                setForm({ ...form, fecha_fin_estimada: e.target.value })
              }
              required
            />
          </div>
          <div>
            <Label>Prioridad</Label>
            <Select
              value={form.prioridad}
              onChange={(v: any) => setForm({ ...form, prioridad: v })}
              options={[
                { value: "1", label: "Baja" },
                { value: "2", label: "Media" },
                { value: "3", label: "Alta" },
              ]}
            />
          </div>
          <div className="flex flex-col justify-end">
            <label className="flex items-center gap-2 text-sm">
              <input
                type="checkbox"
                checked={form.requiere_soporte}
                onChange={(e: any) =>
                  setForm({ ...form, requiere_soporte: e.target.checked })
                }
              />{" "}
              Requiere soporte obligatorio
            </label>
          </div>
          <div className="col-span-2">
            <Label>Soporte / Archivo de la actividad</Label>
            <input
              type="file"
              onChange={(e) => setFile(e.target.files?.[0] || null)}
              className="w-full text-sm border rounded-lg p-2"
            />
            {form.soporte_url && (
              <a
                href={form.soporte_url}
                target="_blank"
                className="text-xs text-blue-600 mt-1 block"
              >
                Ver soporte actual
              </a>
            )}
          </div>
        </div>
        <div className="flex gap-3">
          <Button type="submit" disabled={loading}>
            {loading ? "Guardando..." : isEdit ? "Actualizar" : "Crear"}{" "}
            Actividad
          </Button>
          <Button type="button" variant="outline" onClick={onCancel}>
            Cancelar
          </Button>
        </div>
      </form>
    </div>
  );
}
